import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAssetPrice } from "../../../redux/trade-form/tradeFormSlice";
import useAssetAmount from "./useAssetAmount";

const useAssetPrice = () => {
  const {
    main: { userData },
    tradeForm: {
      targetCoin,
      targetExchange,
      tradeType,
      assetPrice,
      assetPriceStatus,
    },
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  const intervalRef = useRef(null);
  const previousCoinRef = useRef(null);

  const { isAssetInPortfolio } = useAssetAmount();

  const isValidPrice = assetPrice && assetPriceStatus === "success";

  const username = userData?.["custom:custom_username"];
  const sub = userData?.["cognito:username"];

  // 🔹 1. Fetch on mount or dependency change
  useEffect(() => {
    if (!userData?.email || !targetCoin || !targetExchange) return;
    if (tradeType === "sell" && !isAssetInPortfolio) return;

    dispatch(getAssetPrice(username, sub, targetExchange, targetCoin));
    previousCoinRef.current = targetCoin;
  }, [
    dispatch,
    userData?.email,
    username,
    sub,
    targetCoin,
    targetExchange,
    tradeType,
    isAssetInPortfolio,
  ]);

  // 🔹 2. Polling every 60 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      if (!userData?.email || !targetCoin || !targetExchange) return;
      if (tradeType === "sell" && !isAssetInPortfolio) return;

      const currentCoin = targetCoin;
      const previousCoin = previousCoinRef.current;

      const shouldFetch =
        currentCoin !== previousCoin ||
        (currentCoin === previousCoin && isValidPrice);

      if (shouldFetch) {
        dispatch(getAssetPrice(username, sub, targetExchange, currentCoin));
        previousCoinRef.current = currentCoin;
      }
    }, 60000);

    return () => clearInterval(interval);
  }, [
    dispatch,
    userData?.email,
    username,
    sub,
    targetCoin,
    targetExchange,
    tradeType,
    isAssetInPortfolio,
    isValidPrice,
  ]);

  return null; // No need to return data since Redux handles state
};

export default useAssetPrice;
